/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import { loc } from "../../../../core/utils"
import genericSchema from "../IdentificationPageValidator"
import * as yup from "yup"

/* regex */
const phoneRegex = /^\+33(6|7){1}[0-9]{8}$/
const phoneRegexFr = /^0(6|7){1}[0-9]{8}$/
const emailRegex = /^[a-zA-Z0-9_\-.]+@[a-zA-Z0-9_\-.]+\.[a-zA-Z0-9_\-.]+$/
const emailNotValidMessage = () => loc`Email invalid`
const defaultRegex =
  /^[a-zA-ZêëéèçÊËÉÈÇàâäÀÂ' ÄùûüÙÛÜìïîÌÏÎòôöÒÔÖ]+(([ -][a-zA-Z êëéèçÊËÉÈÇàâäÀÂÄùûüÙÛÜìïîÌÏÎòôöÒÔÖ])?[a-zA-ZêëéèçÊËÉÈÇàâäÀÂÄùûüÙÛÜìïîÌÏÎòôöÒÔÖ]*)*$/

/* error messages */
const phoneNumberMessage = () => loc`Invalid phone number`
const requiredMessage = () => loc`Required`
const maximumCharactersMessage = (maximumValue) => maximumValue + " " + loc`maximum characters`
const unauthorizedCharactersMessage = () => loc`Unauthorized characters`

let schema = yup.object().shape({
  identity: yup.object().shape({
    name: yup
      .string()
      .nullable()
      .required(requiredMessage)
      .max(25, maximumCharactersMessage(25))
      .matches(defaultRegex, unauthorizedCharactersMessage()),
    firstName: yup
      .string()
      .nullable()
      .max(25, maximumCharactersMessage(25))
      .required(requiredMessage)
      .matches(defaultRegex, unauthorizedCharactersMessage())
  }),
  coordinates: yup.object().shape({
    phoneNumber: yup
      .string()
      .nullable()
      .required(requiredMessage)
      .test({
        name: "phone verification",
        message: "",
        test(value) {
          const phoneValueWithoutSpaces = value?.replace(/\s/g, "")
          if (!phoneValueWithoutSpaces?.match(phoneRegex) && !phoneValueWithoutSpaces?.match(phoneRegexFr)) {
            return this.createError({
              message: phoneNumberMessage,
              path: "coordinates.phoneNumber"
            })
          }
        }
      }),
    email: yup
      .string()
      .nullable()
      .required(requiredMessage)
      .test({
        name: "email",
        message: "",
        test(value) {
          if (!value?.match(emailRegex)) {
            return this.createError({
              message: emailNotValidMessage,
              path: "coordinates.email"
            })
          }
        }
      })
  })
})

export default (values) => {
  return schema.concat(genericSchema).validate(values, { abortEarly: false, context: values })
}
